import React from 'react';
import { useSelector } from 'react-redux';
import TotalAmount from './TotalAmount';
import WishlistCard from './WishlistCard';

const Wishlist = () => {
    const { total, totalItems, wishlist } = useSelector(state => state.wishlist);

    return (
        <div className='text-richblack-5'>
            <div className='flex flex-col sm:flex-row items-center justify-between'>
                <header className='text-[26px] font-semibold sm:mb-14 mb-4'>
                    My Wishlist
                </header>
                <div>
                    <TotalAmount
                        total={total}
                        wishlist={wishlist}
                    />
                </div>
            </div>
            <p className='text-richblack-200 font-bold border-b border-b-richblack-400 my-4'>{totalItems} Courses in Wishlist</p>
            <div>
                {wishlist.length > 0
                    ? (
                        <div className='py-5 w-full'>
                            {wishlist.map((course) => (
                                <div key={course._id}>
                                    <WishlistCard
                                        course={course}
                                    />
                                </div>
                            ))}
                        </div>
                    )
                    : (
                        <div className='text-2xl font-bold text-center my-10'>
                            <p>Your Wishlist is Empty</p>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default Wishlist;